import Button, { ButtonProps } from "@/shared/form/button";
import { UploadOutlined } from "@ant-design/icons";
import { useTranslations } from "use-intl";

export function UploadButton(props: ButtonProps) {
  const t = useTranslations("Common");

  return (
    <Button icon={<UploadOutlined />} {...props}>
      {t("Upload")}
    </Button>
  );
}
